import React, { useState, useLayoutEffect,useRef } from "react";
import clsx from "clsx";

const clamp = (value) => Math.max(0, value);

const isBetween = (value, floor, ceil) => value >= floor && value <= ceil;

// hooks
const useScrollspy = (ids, offset = 0) => {
  const [activeId, setActiveId] = useState("");

  useLayoutEffect(() => {
    const listener = () => {
      const scroll = window.pageYOffset;

      const position = ids
        .map((id) => {
          const element = document.getElementById(id);

          if (!element) return { id, top: -1, bottom: -1 };

          const rect = element.getBoundingClientRect();
          const top = clamp(rect.top + scroll - offset);
          const bottom = clamp(rect.bottom + scroll - offset);

          return { id, top, bottom };
        })
        .find(({ top, bottom }) => isBetween(scroll, top, bottom));

      setActiveId(position?.id || "");
    };

    listener();

    window.addEventListener("resize", listener);
    window.addEventListener("scroll", listener);

    return () => {
      window.removeEventListener("resize", listener);
      window.removeEventListener("scroll", listener);
    };
  }, [ids, offset]);

  return activeId;
};
const Navbar = () => {
  const themeButton = useRef('');
 
  const [isActive, setIsActive] = useState(false);
  const handleClick = (event) => {
    // ️ toggle isActive state on click
    setIsActive((current) => !current);
  };
 
 /*==================== SCROLL SECTIONS ACTIVE LINK ====================*/
  const ids = ["home", "about", "skills", "services", "portfolio", "contact"];
  const activeId = useScrollspy(ids, 50); // 54 is navigation height

  /*==================== REMOVE MENU MOBILE ====================*/
  const navLink = document.querySelectorAll(".nav__link");

  function linkAction() {
    debugger;
    const navMenu = document.getElementById("nav-menu");
    // When we click on each nav__link, we remove the show-menu class
    navMenu.classList.remove("show-menu");
  }
  navLink.forEach((n) => n.addEventListener("click", linkAction));

  
  

  /*==================== CHANGE BACKGROUND HEADER ====================*/
  function scrollHeader() {
    const header = document.getElementById("header");
    // When the scroll is greater than 100 viewport height, add the scroll-header class to the header tag
    if (this.scrollY >= 80) header.classList.add("scroll-header");
    else header.classList.remove("scroll-header");
  }
  window.addEventListener("scroll", scrollHeader);

/*==================== DARK LIGHT THEME ====================*/ 
// const themeButton = document.getElementById('theme-button')
const darkTheme = 'dark-theme'
const iconTheme = 'uil-sun'

// Previously selected topic (if user selected)
const selectedTheme = localStorage.getItem('selected-theme')
const selectedIcon = localStorage.getItem('selected-icon')

// We obtain the current theme that the interface has by validating the dark-theme class
const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? 'dark' : 'light'
const getCurrentIcon = () =>themeButton.current.classList.contains(iconTheme) ? 'uil-moon' : 'uil-sun'

// We validate if the user previously chose a topic
if (selectedTheme) {
  // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
  document.body.classList[selectedTheme === 'dark' ? 'add' : 'remove'](darkTheme)
  //console.log(themeButton.current.classList);
  //themeButton.current.classList[selectedIcon === 'uil-moon' ? 'add' : 'remove'](iconTheme)
}

// Activate / deactivate the theme manually with the button
const handleChangeTheme = (event) => {
  debugger
  // Add or remove the dark / icon theme
  document.body.classList.toggle(darkTheme)
  themeButton.current.classList.toggle(iconTheme)
  // We save the theme and the current icon that the user chose
  localStorage.setItem('selected-theme', getCurrentTheme())
  localStorage.setItem('selected-icon', getCurrentIcon())
};


  return (
    <>
      <header className="header" id="header">
        <nav className="nav container">
          <a href="#home" className="nav__logo">
            Renuka
          </a>
          <div
            className={`nav__menu ${isActive ? "show-menu" : ""}`}
            id="nav-menu"
          >
            <ul className="nav__list grid">
              <li className="nav__item">
                <a
                  href="#home"
                  className={clsx(
                    "nav__link",
                    "home" === activeId && "active-link"
                  )}
                >
                  <i className="uil uil-estate nav__icon"></i> Home
                </a>
              </li>
              <li className="nav__item">
                <a
                  href="#about"
                  className={clsx(
                    "nav__link",
                    "about" === activeId && "active-link"
                  )}
                >
                  <i className="uil uil-user nav__icon"></i> About
                </a>
              </li>
              <li className="nav__item">
                <a
                  href="#skills"
                  className={clsx(
                    "nav__link",
                    "skills" === activeId && "active-link"
                  )}
                >
                  <i className="uil uil-file-alt nav__icon"></i> Skills
                </a>
              </li>
              {/* <li className="nav__item">
                <a
                  href="#services"
                  className={clsx(
                    "nav__link",
                    "services" === activeId && "active-link"
                  )}
                >
                  <i className="uil uil-briefcase-alt nav__icon"></i> Services
                </a>
              </li> */}
              <li className="nav__item">
                <a
                  href="#portfolio"
                  className={clsx(
                    "nav__link",
                    "portfolio" === activeId && "active-link"
                  )}
                >
                  <i className="uil uil-scenery nav__icon"></i> Portfolio
                </a>
              </li>
              <li className="nav__item">
                <a
                  href="#contact"
                  className={clsx(
                    "nav__link",
                    "contact" === activeId && "active-link"
                  )}
                >
                  <i className="uil uil-message nav__icon"></i> Contact me
                </a>
              </li>
            </ul>
            <i
              className="uil uil-times nav__close"
              id="nav-close"
              onClick={handleClick}
            ></i>
          </div>

          <div className="nav__btns">
            <i className="uil uil-moon change-theme" id="theme-button"  ref={themeButton} onClick={handleChangeTheme}></i>
            <div id="nav-toggle" className="nav__toggle" onClick={handleClick}>
              <i className="uil uil-apps"></i>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
